import axios from "../../config/AxiosConfig";
import useSWR from "swr";

import { GET_WALLET_DETAILS_API, REFRESH_ANB_WALLET_TRANSACTION_API } from "../../store/actions/apiCollections";

export const walletTransactionFetcher = (url) =>
	axios.get(url).then((response) => response.data.data.data);

export const walletDetailsFetcher = (url) =>
	axios.get(url).then((response) => response.data.data.data);

export const withdrawFromWallet = (url, { arg }) =>
	axios.post(url, arg).then((response) => response.data.data.data);

export const walletTopup = (url, { arg }) =>
	axios.post(url, arg).then((response) => response.data.data.data);

export const refreshWalletTransactionFetcher = (url) =>
	axios.get(url).then((response) => response.data.data.data);

export const useWalletDetailsFetcher = (currencyId) => {
	const {
		data: walletDetails,
		isValidating,
		mutate,
	} = useSWR(
		currencyId ? `${GET_WALLET_DETAILS_API}?&currencyId=${currencyId}` : "",
		walletDetailsFetcher,
		{
			keepPreviousData: true,
			revalidateOnFocus: false,
		}
	);

	return { walletDetails, isValidating, mutate };
};

export const useRefreshWalletTransactionFetcher = () => {
	const { data, isValidating, mutate } = useSWR(
    `${REFRESH_ANB_WALLET_TRANSACTION_API}?lng=${localStorage.getItem("i18nextLng")}`,
    refreshWalletTransactionFetcher,
    {
      keepPreviousData: true,
      revalidateOnFocus: false,
    },
  );

	return { data, isValidating, mutate };
};
